import { useState } from "react";
import { WarningIcon } from "vega-icons";

import { InformativeModal } from "@vega-core/components/Modals/InformativeModal/InformativeModal";
import { m } from "@vega-core/paraglide/messages";
import {
  getBrowserSupportInfo,
  getBrowserUpdateUrl,
} from "@vega-core/utils/browserSupport";

export const OUTDATED_BROWSER_ACK_STORAGE_KEY = "vega.outdatedBrowserAck";

const WarningIllustration = (
  <div className="flex items-center justify-center w-32 h-32 sm:w-40 sm:h-40 rounded-full border-[1rem] sm:border-[1.25rem] border-text/pending/10 bg-warning/5 p-4">
    <WarningIcon
      className="w-12 h-12 sm:w-16 sm:h-16 text-text/pending"
      data-testid="WarningIcon"
    />
  </div>
);

export function OutdatedBrowserModal() {
  const [browserInfo] = useState(() => getBrowserSupportInfo());
  const ackKey = `${browserInfo.name}-${browserInfo.major}`;
  const [ackValue, setAckValue] = useState(() =>
    localStorage.getItem(OUTDATED_BROWSER_ACK_STORAGE_KEY),
  );

  const shouldShow = !browserInfo.supported && ackValue !== ackKey;

  const dismiss = () => {
    localStorage.setItem(OUTDATED_BROWSER_ACK_STORAGE_KEY, ackKey);
    setAckValue(ackKey);
  };

  const handleUpdateNow = () => {
    window.open(
      getBrowserUpdateUrl(browserInfo.name),
      "_blank",
      "noopener,noreferrer",
    );
    dismiss();
  };

  if (!shouldShow) return null;

  const description =
    browserInfo.name === "Safari"
      ? `${m.outdatedBrowser_body({
          browserName: browserInfo.name,
          browserVersion: browserInfo.version,
        })} ${m.outdatedBrowser_safariUpdateInstructions()}`
      : m.outdatedBrowser_body({
          browserName: browserInfo.name,
          browserVersion: browserInfo.version,
        });

  return (
    <InformativeModal
      description={description}
      illustration={WarningIllustration}
      isOpen
      onClose={dismiss}
      primaryBtnProps={{
        children: m.outdatedBrowser_updateNow(),
        onClick: handleUpdateNow,
      }}
      secondaryBtnProps={{
        children: m.outdatedBrowser_continueAnyway(),
        onClick: dismiss,
      }}
      title={m.outdatedBrowser_title()}
    />
  );
}
